import React from "react";
import PropTypes from "prop-types";

const IconBack = (props) => {
  return (
    <svg
      width={props.width ? props.width : "33"}
      height={props.height ? props.height : "26"}
      viewBox="0 0 33 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.53405 10.0892L1.26703 11.3391L0 10.0892L1.26703 8.83933L2.53405 10.0892ZM33 24.2321C33 24.701 32.8112 25.1507 32.4751 25.4822C32.139 25.8137 31.6832 26 31.2079 26C30.7326 26 30.2768 25.8137 29.9407 25.4822C29.6046 25.1507 29.4158 24.701 29.4158 24.2321H33ZM10.2276 20.1784L1.26703 11.3391L3.80107 8.83933L12.7616 17.6787L10.2276 20.1784ZM1.26703 8.83933L10.2276 0L12.7616 2.49976L3.80107 11.3391L1.26703 8.83933ZM2.53405 8.32134H20.4552V11.8571H2.53405V8.32134ZM33 20.6964V24.2321H29.4158V20.6964H33ZM20.4552 8.32134C23.7823 8.32134 26.9731 9.62514 29.3257 11.9459C31.6783 14.2667 33 17.4143 33 20.6964H29.4158C29.4158 18.3521 28.4717 16.1038 26.7913 14.4461C25.1108 12.7884 22.8317 11.8571 20.4552 11.8571V8.32134Z"
        fill={props.color ? props.color : "#FFF"}
      />
    </svg>
  );
};

IconBack.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default IconBack;
